export const filterModuleProperties = (moduleNameProperties) => {
  const { moduleName } = moduleNameProperties;

  if (moduleName === 'DProperties')
    return filterDProperties(moduleNameProperties);

  return moduleNameProperties;
};

// DProperties
const hiddenBlueprintComponentsFields = ['Id', 'ComponentsPartOfId'];

export const filterDProperties = (moduleNameProperties) => {
  const { moduleGroupProperties, moduleProperties } = moduleNameProperties;

  const newModuleProperties = moduleProperties.map((property) => {
    if (property?.propertyName === 'BpComponents') {
      const newChildProperties = property?.childProperties?.filter(
        (property) =>
          !hiddenBlueprintComponentsFields.includes(property?.propertyName)
      );

      return {
        ...property,
        childProperties: newChildProperties,
      };
    }
    return property;
  });

  const newModuleGroupProperties = moduleGroupProperties.map((moduleGroup) => {
    if (moduleGroup?.nameGroup === 'Blueprint Components') {
      const newGroupProperties = moduleGroup?.groupProperties?.map(
        (property) => {
          if (property?.propertyName === 'BpComponents') {
            const newChildProperties = property?.childProperties?.filter(
              (property) =>
                !hiddenBlueprintComponentsFields.includes(
                  property?.propertyName
                )
            );

            return {
              ...property,
              childProperties: newChildProperties,
            };
          }
          return property;
        }
      );
      return {
        ...moduleGroup,
        groupProperties: newGroupProperties,
      };
    }
    return moduleGroup;
  });

  return {
    ...moduleNameProperties,
    moduleGroupProperties: newModuleGroupProperties,
    moduleProperties: newModuleProperties,
  };
};

//
const MEMBER_MODULES_BRICK_CODE = {
  isAwg: {
    modulesBrickCode: 'AwgProperties',
  },
  isLowes: {
    modulesBrickCode: 'LowesExtensions',
  },
};

export const filterBrickCodeModulesByMemberType = (
  modulesBrickCode,
  memberType = {
    isAwg: false,
    isLowes: false,
  }
) => {
  let result = modulesBrickCode;

  for (const [key, value] of Object.entries(MEMBER_MODULES_BRICK_CODE)) {
    const valueMemberType = memberType[key];

    if (!valueMemberType) {
      result = result.filter(
        (brickCodeModule) =>
          brickCodeModule?.toLowerCase() !==
            value?.modulesBrickCode?.toLowerCase() ?? ''
      );
    }
  }

  return result;
};
